export default "__VITE_ASSET__BS6lH_Zt__"